import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "au-topbar" }
const _hoisted_2 = {
  class: "au-crumb",
  "aria-label": "breadcrumb"
}
const _hoisted_3 = { class: "ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LanguageSwitch = _resolveComponent("LanguageSwitch")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'Dashboard' },
        title: _ctx.$t('nav.home'),
        "aria-label": _ctx.$t('nav.home')
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "bi bi-house-door" }, null, -1)
        ])),
        _: 1
      }, 8, ["title", "aria-label"]),
      _cache[1] || (_cache[1] = _createElementVNode("i", {
        class: "bi bi-chevron-right",
        style: {"font-size":"11px"}
      }, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_LanguageSwitch)
    ])
  ]))
}